import ConfirmDialog from './ConfirmDialog.vue';

export default {
  install(Vue) {
    Vue.component('ConfirmDialog', ConfirmDialog);
    Vue.mixin({
      methods: {
        showConfirm(msg, title = '', suppressID) {
          this.$root.$emit('show-confirm', { title, msg, suppressID });
          return new Promise((resolve, reject) => {
            this.$root.$on('hide-confirm', (confirmed) => {
              if (confirmed) {
                resolve(confirmed);
              } else {
                reject(confirmed);
              }
              this.$root.$off('hide-confirm');
            });
          });
        },
      },
    });
  },
};
